import React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import "./index.css";

import Header from "./components/header/Header";
import Header_2 from "./components/header_2/Header_2";
import Footer from "./components/footer/Footer";
import Home from "./components/home/Home";
import Check_your_fit from "./components/check_your_fit/Check_your_fit";
import Advantage from "./components/advantages/Advantage";
import Check_fit_form from "./components/check-fit-form/Check_fit_form";
import Registration from "./components/registration/Registration";
import Privacy_Policy from "./components/privacy_policy/Privacy_Policy";
import Terms_Conditions from "./components/terms_conditions/Terms_Conditions";
import Scroll_to_Top from "./components/scroll_to_top/Scroll_to_Top";
import Registration_Done from "./components/registration_Done/Registration_Done";
import AppointmentWrapper from "./components/appointment/AppointmentWrapper";
import About_us from "./components/about_Us/About_us";

function App() {
  const location = useLocation();

  const isRegistrationPage = location.pathname === "/registration";

  return (
    <>
      <Scroll_to_Top />
      {isRegistrationPage ? <Header_2 /> : <Header />}

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About_us />} />
        <Route path="/advantage" element={<Advantage />} />
        <Route path="/check-your-fit" element={<Check_your_fit />} />
        <Route path="/check-your-form" element={<Check_fit_form />} />
        <Route path="/privacy-policy" element={<Privacy_Policy />} />
        <Route path="/terms-conditions" element={<Terms_Conditions />} />
        <Route path="/registration" element={<Registration />} />
        <Route path="/registration-done" element={<Registration_Done />} />
        <Route path="/schedule-appointment" element={<AppointmentWrapper />} />
      </Routes>

      {!isRegistrationPage && <Footer />}
    </>
  );
}

export default App;
